<template>
  <div class="bg-white borderd">
    <ValidationObserver ref="form" v-slot="{ invalid }">
      <div class="block px-10 py-2 mx-auto mt-0 mb-20">
        <div class="flex">
          <div class="w-1/3 space-y-4">
            <div>
              <ValidationProvider v-slot="{ errors }" name="Användarnamn" rules="required|email">
                <span class="text-gray-700">Användarnamn</span>
                <input v-model="current.userName" type="text" class="w-full mt-1 form-input" :class="{
                    'border-red-600 focus:border-red-600': errors[0]
                  }" />
                <span class="block mt-1 text-sm text-red-500">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div>
              <ValidationProvider v-slot="{ errors }" name="Förnamn" rules="required">
                <span class="text-gray-700">Förnamn</span>
                <input v-model="current.firstName" type="text" class="w-full mt-1 form-input" :class="{
                    'border-red-600 focus:border-red-600': errors[0]
                  }" />
                <span class="block mt-1 text-sm text-red-500">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div>
              <ValidationProvider v-slot="{ errors }" name="Efternamn" rules="required">
                <span class="text-gray-700">Efternamn</span>
                <input v-model="current.lastName" type="text" class="w-full mt-1 form-input" :class="{
                    'border-red-600 focus:border-red-600': errors[0]
                  }" />
                <span class="block mt-1 text-sm text-red-500">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div>
              <ValidationProvider v-slot="{ errors }" name="Email" rules="required|email">
                <span class="text-gray-700">Email</span>
                <input v-model="current.email" type="text" class="w-full mt-1 form-input" :class="{
                    'border-red-600 focus:border-red-600': errors[0]
                  }" />
                <span class="block mt-1 text-sm text-red-500">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div>
              <ValidationProvider name="Bekräftad email">
                <label class="inline-flex items-center mt-5">
                  <input type="checkbox" class="form-checkbox" v-model="current.emailConfirmed" />
                  <span class="form-label ml-2">Bekräftad email</span>
                </label>
              </ValidationProvider>
            </div>
            <div>
              <ValidationProvider name="Resarverad">
                <label class="inline-flex items-center mt-5">
                  <input type="checkbox" class="form-checkbox" v-model="current.reserved" disabled />
                  <span class="form-label ml-2">Resarverad</span>
                </label>
              </ValidationProvider>
            </div>
            <div>
              <ValidationProvider name="Spärrad">
                <label class="inline-flex items-center mt-5">
                  <input type="checkbox" class="form-checkbox" v-model="current.isBlocked" />
                  <span class="form-label ml-2">Spärrad</span>
                </label>
              </ValidationProvider>
            </div>

          </div>
        </div>
        <div class="flex px-2 py-2 mt-12">
          <button class="block btn_default sm:w-auto sm:inline-block" :class="{ 'opacity-50': current.reserved}" :disabled="current.reserved" @click="onDelete">
            Radera
          </button>

          <button class="block w-full btn_blue sm:w-auto sm:inline-block" :class="{ 'opacity-50': isDirty !== true || invalid }" :disabled="isDirty !== true || invalid" @click="onSave">
            Spara
          </button>

          <changepassworddlg class="block w-full sm:w-auto sm:inline-block" />

          <button class="block btn_default sm:w-auto sm:inline-block" :class="{ 'opacity-50': isDirty === true || invalid}" :disabled="isDirty" @click="onConfirmMail">
            Bekräftelsemail
          </button>
        </div>
      </div>
    </ValidationObserver>
    <DialogBase />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { UsersService } from "@/services/api-service";
import ChangePasswordDlg from "./ChangePasswordDlg";
import DialogBase from "@/components/dialogs/DialogBase.vue";
import { destroyDialog } from "@/components/dialogs/dialogs";
import { showMessageDialog } from "@/components/dialogs/dialogs";

export default {
  name: "usergeneral",
  components: { DialogBase, changepassworddlg: ChangePasswordDlg },
  computed: {
    ...mapGetters("usersStore", ["current", "isDirty"])
  },

  methods: {
    ...mapActions("usersStore", ["save", "delete"]),
    async onSave() {
      await this.save();
    },
    async onDelete() {
      const callback = async () => {
        try {
          await this.delete();
        } finally {
          this.$router.push("/users");
          this.$modal.hide("dialog-base");
        }
      };
      destroyDialog(this, callback, "Användare " + this.current.subject);
    },
    async onChangePassword() {
      await this.save();
    },
    async onConfirmMail() {
      const callback = async () => {
        try {
          await UsersService.generateConfirmMail(this.current.subject);
        } finally {
          this.$modal.hide("dialog-base");
        }
      };
      let buttons = [
        {
          title: "Ja",
          handler: callback
        },
        {
          title: "Nej",
          default: true,
          handler: () => {
            this.$modal.hide("dialog-base");
          }
        }
      ];

      showMessageDialog(
        this,
        "Bekräfta",
        "Är du säker på att du vill skicka bekräftelse mail ?",
        buttons
      );
    }
  }
};
</script>
